import type { Locale as AntdLocale } from 'antd/es/locale';
import enUS from 'antd/locale/en_US';
import jaJP from 'antd/locale/ja_JP';
import zhCN from 'antd/locale/zh_CN';
import zhTW from 'antd/locale/zh_TW';
import type { BrandLocale } from 'config/brand';

const antdLocaleMap: Record<BrandLocale, AntdLocale> = {
  'en-US': enUS,
  'ja-JP': jaJP,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
};

const dayjsLocaleMap: Record<BrandLocale, string> = {
  'en-US': 'en',
  'ja-JP': 'ja',
  'zh-CN': 'zh-cn',
  'zh-TW': 'zh-tw',
};

export const getRuntimeDateLocale = (locale: BrandLocale) => ({
  antdLocale: antdLocaleMap[locale],
  dayjsLocale: dayjsLocaleMap[locale],
});
